import { storableError } from '../../util/errors';
import { onCustomerGroupPaymentCollectionFind, onGroupPaymentCollectionFind } from '../../util/api';


import { setInitialValues as setInitialValuesForPaymentMethods } from '../../ducks/paymentMethods.duck';
import { stripeCustomer } from '../CheckoutPage/CheckoutPage.duck';
import { fetchAdminModerator } from '../AdminPanelModeratorsPage/AdminPanelModeratorsPage.duck';

// ================ Action types ================ //

export const FETCH_GROUP_PAYMENT_REQUEST = 'app/SubscriptionCheckoutPage/FETCH_GROUP_PAYMENT_REQUEST';
export const FETCH_GROUP_PAYMENT_SUCCESS = 'app/SubscriptionCheckoutPage/FETCH_GROUP_PAYMENT_SUCCESS';
export const FETCH_GROUP_PAYMENT_ERROR = 'app/SubscriptionCheckoutPage/FETCH_GROUP_PAYMENT_ERROR';

export const VALID_PAYMENT_LINK_REQUEST = 'app/SubscriptionCheckoutPage/VALID_PAYMENT_LINK_REQUEST';
export const VALID_PAYMENT_LINK_SUCCESS = 'app/SubscriptionCheckoutPage/VALID_PAYMENT_LINK_SUCCESS';
export const VAILD_PAYMENT_LINK_ERROR = 'app/SubscriptionCheckoutPage/VAILD_PAYMENT_LINK_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  groupPaymentData: null,

  validPaymentLinkInProgress: false,
  validPaymentLinkError: false,
  validPaymentLinks: []
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_GROUP_PAYMENT_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null, groupPaymentData: null };
    case FETCH_GROUP_PAYMENT_SUCCESS:
      return { ...state, fetchInProgress: false, groupPaymentData: payload, fetchError: null };
    case FETCH_GROUP_PAYMENT_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload, groupPaymentData: null };

    case VALID_PAYMENT_LINK_REQUEST:
      return { ...state, validPaymentLinkInProgress: true, validPaymentLinkError: null, validPaymentLinks: null };
    case VALID_PAYMENT_LINK_SUCCESS:
      return { ...state, validPaymentLinkInProgress: false, validPaymentLinkError: null, validPaymentLinks: payload };
    case VAILD_PAYMENT_LINK_ERROR:
      return { ...state, validPaymentLinkInProgress: false, validPaymentLinkError: payload, validPaymentLinks: null };

    default:
      return state;
  }
}

// ================ Action creators ================ //
export const fetchGroupPaymentRequest = () => ({ type: FETCH_GROUP_PAYMENT_REQUEST });
export const fetchGroupPaymentSuccess = data => ({ type: FETCH_GROUP_PAYMENT_SUCCESS, payload: data });
export const fetchGroupPaymentError = e => ({ type: FETCH_GROUP_PAYMENT_ERROR, payload: e, error: true });


export const validPaymentLinkRequest = () => ({ type: VALID_PAYMENT_LINK_REQUEST });
export const validPaymentLinkSuccess = data => ({ type: VALID_PAYMENT_LINK_SUCCESS, payload: data });
export const validPaymentLinkError = e => ({ type: VAILD_PAYMENT_LINK_ERROR, payload: e, });


export const validPaymentLink = params => async (dispatch, getState, sdk) => {
  dispatch(validPaymentLinkRequest());
  return onCustomerGroupPaymentCollectionFind({
    payload: {
      ...params
    }
  })
    .then((response) => {
      dispatch(validPaymentLinkSuccess(response.data));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "fetchGroupPayment >>>> storableError(e)")
      dispatch(validPaymentLinkError(storableError(e)));
      return e;
    });
};


// ================ Load data ================ //
export const loadData = params => async (dispatch, getState, sdk) => {
  const { paymentId, groupId, customerGroupPaymentId } = params || {};
  dispatch(fetchGroupPaymentRequest());
  dispatch(setInitialValuesForPaymentMethods());
  await dispatch(stripeCustomer());

  const newParams = {
    payload: {
      paymentId,
      groupId
    }
  };

  dispatch(fetchAdminModerator({ payload: { groupId: groupId, status: 'active', role: 'admin', }, }));
  dispatch(validPaymentLink({ customerGroupPaymentId }))

  return onGroupPaymentCollectionFind(newParams)
    .then((response) => {
      const data = response.data[0];
      dispatch(fetchGroupPaymentSuccess(data));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "fetchGroupPayment >>>> storableError(e)")
      dispatch(fetchGroupPaymentError(storableError(e)));
      return e;
    });
};
